<template lang="pug">
.content-center
  .bets-wrap
    ul.d-flex.justify-content-around
      li.flex-grow-1
        a(:class="{'active': selected == 1}" @click="goTab(1)") {{ $t("ui.today") }}
      li.flex-grow-1
        a(:class="{'active': selected == 2}" @click="goTab(2)") {{ $t("ui.seven_days") }}
      li.flex-grow-1
        a(:class="{'active': selected == 3}" @click="goTab(3)") {{ $t("ui.fourteen_days") }}
  .opening-balance
    span.mr-1 {{ $t("ui.opening_balance") }}:
    span(:class="{'text-danger1': opening_balance < 0}") {{ $numeral(opening_balance).format("0,0.00") }}
  .pagepanel
    .page-group
      #statement.statement-group
        template(v-for="(item, index) in dailyStatementList")
          .statement-wrap
            .header
              span.date {{ $dayjs(item.working_date).format("MM/DD/YYYY") }} ({{ $t("ui." + $dayjs(item.working_date).format("dddd").toLowerCase()) }})
              span.stake {{ $t("ui.stake") }}: {{ $numeral(item.turnover).format("0,0.00") }}
            .statement-info.collapsed(data-toggle='collapse' :data-target="'#statement-' + index" aria-expanded='false' :aria-controls="'statement-' + index" @click="getDayGameResult('sportsbook', item.working_date)")
              .statement-col
                .small-text {{ $t("ui.winlose") }}
                .amount.mr-1(:class="{'lose': item.winlose < 0, 'won': item.winlose > 0}") {{ $numeral(item.winlose).format("0,0.00") }}
                .comm {{ $numeral(item.comm).format("0,0.00") }}
              .statement-col
                .small-text {{ $t("ui.settlement") }}
                .amount(:class="{'lose': item.settled_amount < 0, 'won': item.settled_amount > 0}") {{ $numeral(item.settled_amount).format("0,0.00") }}
              .statement-col
                .small-text {{ $t("ui.balance") }}
                .amount(:class="{'lose': item.cash_balance < 0, 'won': item.cash_balance > 0}") {{ $numeral(item.cash_balance).format("0,0.00") }}
            .collapse(:id="'statement-' + index" data-parent="#statement")
              .statement-filter-wrapper
                .dropdown-btn(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false') {{ filterMenu == 'lottery' ? $t("ui.w4d") : $t("ui." + filterMenu) }}
                  ul.dropdown-menu.statement(:id="'filterMenu-' + index")
                    li
                      a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'sportsbook')") {{ $t("ui.sportsbook") }}
                    template(v-if="!whiteLabel")
                      li
                        a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'livecasino')") {{ $t("ui.livecasino") }}
                      li
                        a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'slots')") {{ $t("ui.slots") }}
                      li
                        a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'lottery')") {{ $t("ui.w4d") }}
                      li(v-if="esports2")
                        a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'esports2')") {{ $t("ui.esports2") }}
                    li
                      a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'transfer')") {{ $t("ui.transfer") }}
                    li
                      a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'void')") {{ $t("ui.void") }}
                    li
                      a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'tournament')") {{ $t("ui.tournament") }}
                    li
                      a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'tournament_refund')") {{ $t("ui.tournament_refund") }}
                    //- li
                    //-   a.dropdown-item(@click="setFilterMenu('filterMenu-' + index, 'adjustment')") {{ $t("ui.adjustment") }}
                .total {{ $t("ui.stake") }}: {{ $numeral(totalTurnover).format("0,0.00") }}
              .pagination-wrapper
                v-pagination(
                  v-model="currentPage"
                  :page-count="gameResultTotalPages"
                  :classes="bootstrapPaginationClasses"
                  :labels="paginationAnchorTexts"
                  @input="changedPage($event)"
                  v-if="gameResultTotalPages"
                )
              template(v-if="loading")
                .message.dark
                  .empty.text-center.pt-4
                    .loading-wrap.mb-2
                      .loading
                        .block
                        .block
                        .block
                  p.no-message.text-center.text-dark {{ $t("ui.loading") }}
              template(v-else)
                template(v-if="gameResultList.length <= 0")
                  .message.dark
                    .empty.text-center.pt-4
                      i.fad.fa-exclamation-triangle
                    p.no-message.text-center.text-dark {{ $t("message.no_information_available") }}
                template(v-else)
                  template(v-for="match in gameResultList")
                    template(v-if="match.working_date && $dayjs(item.working_date).format('MM/DD/YYYY') == $dayjs(match.working_date).format('MM/DD/YYYY')")
                      template(v-if="['MMK','MMO'].includes($store.getters.currencyCode)")
                        template(v-if="match.bet_type == 'PARLAY' || match.is_combo")
                          betSlipParlayMMO(:index="index" :match="match" :filterMenu="filterMenu")
                        template(v-else)
                          betSlipMMO(:index="index" :match="match" :filterMenu="filterMenu" :leagueList="mainLeague" :matchList="mainMatch" isStatement=true)
                      template(v-else)
                        template(v-if="match.bet_type == 'PARLAY' || match.is_combo")
                          betSlipParlay(:index="index" :match="match" :filterMenu="filterMenu")
                        template(v-else)
                          betSlip(:index="index" :match="match" :filterMenu="filterMenu" :leagueList="mainLeague" :matchList="mainMatch" isStatement=true)

                    template(v-if="match.match_date && $dayjs(item.working_date).format('MM/DD/YYYY') == $dayjs(match.match_date).format('MM/DD/YYYY')")
                      betSlip4d(:match="match")
              .pagination-wrapper
                v-pagination(
                  v-model="currentPage"
                  :page-count="gameResultTotalPages"
                  :classes="bootstrapPaginationClasses"
                  :labels="paginationAnchorTexts"
                  @input="changedPage($event)"
                  v-if="gameResultTotalPages"
                )
</template>

<script>
import vPagination from "vue-plain-pagination";
import config from "@/config";
import errors from "@/errors";
import service from "@/library/_xhr-statement";
import betSlip from "@/components/mobile/bets/betSlip";
import betSlipParlay from "@/components/mobile/bets/betSlipParlay";
import betSlip4d from "@/components/mobile/bets/betSlip4d";

import betSlipMMO from "@/components/mobile/bets/mmo/betSlip";
import betSlipParlayMMO from "@/components/mobile/bets/mmo/betSlipParlay";

export default {
  components: {
    vPagination,
    betSlip,
    betSlipParlay,
    betSlip4d,
    betSlipMMO,
    betSlipParlayMMO
  },
  data() {
    return {
      loading: false,
      selected: 1,
      opening_balance: 0,
      totalTurnover: 0,
      filterMenu: "sportsbook",
      mainMatch: [],
      mainLeague: [],
      dailyStatementList: [],
      platformWinloseList: [],
      gameResultList: [],
      currDate: null,
      feedback: {
        success: false,
        status: errors.session.invalidSession
      },
      currentGameResultPage: 1,
      gameResultTotalRow: 0,
      gameResultTotalPages: 0,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      }
    }
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    }
  },
  mounted() {
    this.getDailyStatement();
  },
  methods: {
    goTab(e) {
      this.selected = e;
      this.currentGameResultPage = 1;
      this.getDailyStatement();
    },
    expandFilter(id, evt) {
      evt.stopPropagation();
      $('#' + id + '.statement-filter-menu').slideToggle();
    },
    setFilterMenu(id, e) {
      this.filterMenu = e;
      this.currentGameResultPage = 1;
      switch(e) {
        case "transfer":
          this.getSettlement(this.currDate);
          break;
        case "void":
          this.getCancelledBetList();
          break;
        default:
          this.getGameResult(e, this.currDate);
          break;
      }

      // if(e == 'transfer') {
      //   this.getSettlement(this.currDate);
      // } else {
      //   this.getGameResult(e, this.currDate);
      // }
      $('#' + id + '.statement-filter-menu').hide();
    },
    getDailyStatement() {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken
      };

      this.loading = true;
      this.dailyStatementList = [];

      service.getDailyStatement(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success) {
              switch(this.selected) {
                case 2:
                  this.opening_balance = result.data[6].account_opening;
                  this.dailyStatementList = result.data.slice(0,7);
                  break;
                case 3:
                  this.opening_balance = result.data[13].account_opening;
                  this.dailyStatementList = result.data;
                  break;
                default:
                  this.opening_balance = result.data[0].account_opening;
                  this.dailyStatementList = [result.data[0]];
                  break;
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getPlatformWinlose(date) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        start_date: date,
        end_date: date
      };

      this.loading = true;
      this.totalTurnover = 0;

      service.getPlatformWinlose(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              let list = result.data;
              if(list.length > 0) {
                list.forEach(x => {
                  if(x.product == this.filterMenu.toUpperCase()) {
                    this.totalTurnover = x.turnover;
                  }
                });
              }

            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getDayGameResult(product, date) {
      this.currentPage = 1;
      this.currentGameResultPage = 1;
      this.getGameResult(product, date);
    },
    getGameResult(product, date) {
      this.filterMenu = product.toLowerCase();
      this.currDate = date;
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        start_date: this.currDate,
        end_date: this.currDate,
        category_type: this.filterMenu,
        page_number: this.currentGameResultPage,
        page_size: this.getPageSize,
        match_id: null,
        bet_type: null
      };

      this.loading = true;
      this.gameResultList = [];
      this.gameResultTotalRow = 0;
      this.gameResultTotalPages = 0;

      service.getGameResult(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.gameResultList = result.data["Table"];
              if(['sportsbook','adjustment'].includes(this.filterMenu)) {
                this.mainMatch = result.names["Table"];
                this.mainLeague = result.names["Table1"];
              }
              this.gameResultTotalRow = this.gameResultList.length > 0 ? this.gameResultList[0].totalrows : 0;
              if (this.gameResultTotalRow % this.getPageSize != 0) this.gameResultTotalPages = Math.ceil(parseFloat(this.gameResultTotalRow) / parseFloat(this.getPageSize));
              else this.gameResultTotalPages = parseFloat(this.gameResultTotalRow) / parseFloat(this.getPageSize);

              this.getPlatformWinlose(this.currDate);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getSettlement(date) {
      this.currDate = date;

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        working_date: date
      };

      this.loading = true;
      this.gameResultList = [];
      this.gameResultTotalRow = 0;
      this.gameResultTotalPages = 0;

      service.getSettlement(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.gameResultList = result.data;
              // this.gameResultTotalRow = this.gameResultList.length > 0 ? this.gameResultList[0].totalrows : 0;
              // if (this.gameResultTotalRow % this.getPageSize != 0) this.gameResultTotalPages = Math.ceil(parseFloat(this.gameResultTotalRow) / parseFloat(this.getPageSize));
              // else this.gameResultTotalPages = parseFloat(this.gameResultTotalRow) / parseFloat(this.getPageSize);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getCancelledBetList(mode) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        working_date: this.currDate,
        page_number: this.currentGameResultPage,
        page_size: this.getPageSize,
        mode: mode
      };

      this.loading = true;
      this.gameResultList = [];
      this.gameResultTotalRow = 0;
      this.gameResultTotalPages = 0;

      service.getCancelledBetList(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              // var g = result.data;
              // this.gameResultList = g;
              this.gameResultList = result.data;
              if(this.filterMenu == 'void') {
                this.mainMatch = result.names["Table"];
                this.mainLeague = result.names["Table1"];
              }

              // if (result.names) {
              //   var mm = g.reduce((groups, item) => {
              //     const val = item["match_id"];
              //     groups[val] = groups[val] || [];
              //     groups[val].push(item);
              //     return groups;
              //   }, {});

              //   var ll = g.reduce((groups, item) => {
              //     const val = item["league_id"];
              //     groups[val] = groups[val] || [];
              //     groups[val].push(item);
              //     return groups;
              //   }, {});

              //   var m = result.names["Table"];
              //   var l = result.names["Table1"];
              //   if (m) {
              //     for (var i = 0; i < m.length; i++) {
              //       var hn = m[i]["home_name_" + this.language];
              //       var an = m[i]["away_name_" + this.language];
              //       var mid = m[i]["match_id"];

              //       if (hn || an) {
              //         for (var j = 0; j < mm[mid].length; j++) {
              //           if (hn) mm[mid][j]["home_team_name"] = hn;
              //           if (an) mm[mid][j]["away_team_name"] = an;
              //         }
              //       }
              //     }
              //   }

              //   if (l) {
              //     for (var i = 0; i < l.length; i++) {
              //       var ln = l[i]["name_" + this.language];
              //       var lid = l[i]["league_id"];

              //       if (ln) {
              //         for (var j = 0; j < ll[lid].length; j++) {
              //           ll[lid][j]["league_name"] = ln;
              //         }
              //       }
              //     }
              //   }
              // }

              // this.gameResultList = result.data;
              this.gameResultTotalRow = this.gameResultList.length > 0 ? this.gameResultList[0].totalrows : 0;
              if (this.gameResultTotalRow % this.getPageSize != 0) this.gameResultTotalPages = Math.ceil(parseFloat(this.gameResultTotalRow) / parseFloat(this.getPageSize));
              else this.gameResultTotalPages = parseFloat(this.gameResultTotalRow) / parseFloat(this.getPageSize);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    changedPage(pageNo) {
      this.currentGameResultPage = pageNo;
      this.getGameResult(this.filterMenu, this.currDate);
    }
  }
};
</script>